<template>
<div class="row justify-content-md-center">
  <div class="homeLandingLogin"></div>
  <div class="col-sm-9 mt-5">
  <div v-if="loading && user.authenticated" class="login col-md-6 mt-5">
    <h2 class="text-center">Loading...</h2>
  </div>
    <div class="container" v-if="isLoaded && user.authenticated">
    <section v-if="errored" id="contractsView">
    <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section>

    <section v-else >
    <div v-if="loading">
      <h2 class="text-center">Loading...</h2>
    </div>
    <div v-else v-for="( result, key ) in items" :key="result.contractID" id="contractsView">
    <div class="row">
    <div class="col-sm-10">
      <h2>Contract {{result.contractID}}  -   {{result.contractName}}</h2>
      <p>STATUS: {{result.currentStatus}}</p>

    </div>
    <div class="col-lg-2"><button v-if="canMakePayment(result)" class="btn btn-success btn-block" @click="makeAPayment_NewTab(result.branchURL)">Make a Payment</button></div>
    </div>
    <div class="row" v-if="showMigrationNotice(result)">
    <div class="col">
      <div class="alert alert-info" role="alert">
        <p><strong>Your Customer Portal Is Moving</strong></p>
        <p>We’re transitioning from the Pawnee customer portal to the NMEF customer portal. The current portal will automatically redirect you to the new site, where you’ll need to create a new login to access your account.</p>
        <p>To get started, visit the <a href="https://customer.nmef.com/?brand=pawnee" target="_blank">NMEF Customer Portal</a>, click “Enroll Now,” and register using your SSN or EIN. Please use the email address on file with your existing account to receive the verification code needed to complete setup.</p>
        <p>We’re here to help make this transition as smooth as possible. Please contact our team at <a href="mailto:Portal@nmef.com">Portal@nmef.com</a> with any questions or for assistance enrolling.</p>
      </div>
    </div>
    </div>
    <div class="row" v-if="result.currentStatus != 'Transferred to NMEF Securitization'">
    <div class="col-lg-2">
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId(key)">Payment History</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId2(key)">Documents</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId3(key)">Vendor Info</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId4(key)">Broker Info</button>
    </div>
    <div class="col-lg-8" id="contractData">
    <div class="row mb-4">
    <div class="col">
      <span><strong>Original Equipment Cost</strong></span><br>{{result.amtFinanced | currency}}
    </div>
    <div class="col">
      <span><strong>Start Date</strong></span><br>{{result.startDate | moment("MM-DD-YYYY") }}
    </div>
    <div class="col"><span><strong>Maturity Date</strong></span><br>{{result.maturityDate | moment("MM-DD-YYYY")}}
    </div>
    </div>
    <div class="row mb-4">
    <div class="col">
      <span><strong>Contract Payment Amount</strong></span><br>{{result.paymentAmt | currency}}
    </div>
    <div class="col">
    </div>
    <div class="col">
      <span><strong>Current Term</strong></span><br>{{result.terms}}
    </div>
    </div>
    <div class="row mb-4" >
      <div class="col">
        <span><strong>Next Due Date</strong></span><br><span v-if="result.nextDueDate">{{result.nextDueDate | moment("MM-DD-YYYY")}}</span><span v-else >N/A</span>
        </div>
        <div class='col'>
          <span><strong>Total Past Due</strong></span><span :class="{ 'text-danger': checkTotalPastDue(result.totalAmtDue) }"><br>{{result.totalAmtDue | currency}}</span></div>
        <div class='col'>
          <span><strong>Purchase Option**</strong></span><br>{{result.purchaseOptions}}
          </div>
          </div>
    </div>
    <div class="col-lg-2">
      <button type="button" class="btn btn-primary btn-block" v-bind:class="isActive" v-b-modal.modal-center="modalId5(key)">Insurance Info</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId6(key)">Contract Detail</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId7(key)">Bank Account Info</button><br>
      <button type="button" class="btn btn-primary btn-block" v-b-modal.modal-center="modalId8(key)">Wire Instructions</button>
    </div>
    </div>
    <div v-else>
      <p>This contract has been transferred to North Mill Equipment Finance. Please go to <a href="https://customer.nmef.com" target="_blank">customer.nmef.com</a> to access your customer portal. Call <a href="tel:8008644266">800-864-4266</a> with any questions.</p>
    </div>

<b-modal :id="'modal' + key" :title="'Payment History for Contract ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalHistory :parent-data="result.contractID"></modalHistory>
</b-modal>
<b-modal :id="'modal2' + key" :title="'Document Information for Contract ' + result.contractID" :ref="'modal' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalDocuments :parent-data="result.contractID" :modalid="'modal2' + key"></modalDocuments>
</b-modal>
<b-modal :id="'modal3' + key" :title="'Vendor Information for Contract ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalVendor :parent-data="result.contractID"></modalVendor>
</b-modal>
<b-modal :id="'modal4' + key" :title="'Broker Information for Contract ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalBroker :parent-data="result.contractID"></modalBroker>
</b-modal>
<b-modal :id="'modal5' + key" :title="'Insurance Information for Contract ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalInsurance :parent-data="result.contractID" v-bind:startClass="isActive" modalchild="'modal5' + key" v-on:changeClass="changeTheClass($event)"></modalInsurance>
</b-modal>
<b-modal :id="'modal6' + key" :title="'Contract Details for Contract ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalContract :parent-data="result.contractID"></modalContract>
</b-modal>
<b-modal :id="'modal7' + key" :title="'Bank Account Information ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalBilling :parent-data="result.contractID"></modalBilling>
</b-modal>
<b-modal :id="'modal8' + key" title="Wire Instructions" size="lg" centered hide-footer no-close-on-backdrop>
      <modalWireInstructions :parent-data="result.contractID"></modalWireInstructions>
</b-modal>
<b-modal :id="'modalWireInstructions'+ result.contractID" title="Wire Instructions" size="lg" centered hide-footer no-close-on-backdrop>
      <modalWireInstructions :parent-data="result.contractID"></modalWireInstructions>
</b-modal>
<b-modal :id="'modalRequestPayoff' + result.contractID" :title="'Request Pay Off ' + result.contractID" size="lg" centered hide-footer no-close-on-backdrop>
      <modalRequestPayoff :parent-data="result.contractID" :messageresult="message"></modalRequestPayoff>
</b-modal>
<b-modal :id="'modalFees' + result.contractID" title="Fee Information" size="lg" centered hide-footer no-close-on-backdrop>
      <modalFees :parent-data="result.contractID"></modalFees>
</b-modal>
<b-modal :id="'modalACH' + result.contractID" title="ACH Form"  size="lg" centered hide-footer no-close-on-backdrop>
      <modalACH :parent-data="result.contractID" :modalachid="'modalACH' + key"></modalACH>
</b-modal>
<b-modal :id="'modalCC' + result.contractID" title="CC Form" size="lg" centered hide-footer no-close-on-backdrop>
      <modalCC :parent-data="result.contractID" :modalachid="'modalCC' + key"></modalCC>
</b-modal>
</div>
</section>
<div class="row mt-4">
<div class="col" style="color:#ffffff; font-size:0.7em; padding-bottom:80px;">
<h2>-Note: Some changes will not reflect for 24 hrs-</h2>
<p>* Maturity Date may not include purchase option.<br>** Purchase Option available at the end of the term, if applicable.<br>**** Payoff quotations may not reflect the entire amount due, please call PLC to verify.</p>
</div>
</div>
</div>
<div class="container" v-if="!user.authenticated">
  <div class="row">
    <div class="col">
    <h2 class="text-center">Please <router-link to="/login">Login</router-link> to view any contract information</h2>
    </div>
  </div>
</div>
</div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import modalHistory from './modalHistory'
import modalDocuments from './modalDocuments'
import modalVendor from './modalVendor'
import modalBroker from './modalBroker'
import modalInsurance from './modalInsurance'
import modalContract from './modalContract'
import modalBilling from './modalBilling'
import modalWireInstructions from './modalWireInstructions'
import modalRequestPayoff from './modalRequestPayoff'
import modalFees from './modalFees'
import modalACH from './modalACH'
import modalCC from './modalCC'
import auth from './auth'

export default {
  name: 'Contracts',
  components: {
    'modalHistory': modalHistory,
    'modalDocuments': modalDocuments,
    'modalVendor': modalVendor,
    'modalBroker': modalBroker,
    'modalInsurance': modalInsurance,
    'modalContract': modalContract,
    'modalBilling': modalBilling,
    'modalWireInstructions': modalWireInstructions,
    'modalRequestPayoff': modalRequestPayoff,
    'modalFees': modalFees,
    'modalACH': modalACH,
    'modalCC': modalCC
  },
  props: {
    messageresult: {
      type: Boolean
    }
  },
  data: function () {
    return {
      items: null,
      loading: true,
      errored: false,
      parentData: '',
      modalid: '',
      message: true,
      user: auth.user,
      isActive: 'something here',
      apiUrl: localStorage.getItem('apiURL'),
      redirectTimer: null
    }
  },
  methods: {
    modalId (key) {
      return 'modal' + key
    },
    modalId2 (key) {
      return 'modal2' + key
    },
    modalId3 (key) {
      return 'modal3' + key
    },
    modalId4 (key) {
      return 'modal4' + key
    },
    modalId5 (key) {
      return 'modal5' + key
    },
    modalId6 (key) {
      return 'modal6' + key
    },
    modalId7 (key) {
      return 'modal7' + key
    },
    modalId8 (key) {
      return 'modal8' + key
    },
    canMakePayment (contract) {
      return (contract.currentStatus !== 'Transferred to NMEF Securitization') && (contract.currentStatus !== 'Terminated')
    },
    showMigrationNotice (contract) {
      // FAS-7978: Pawnee -> NMEF CP migration notice. Securitized contracts already
      // carry the FAS-7003 "Transferred to NMEF Securitization" message, so exclude them.
      return contract.currentStatus !== 'Transferred to NMEF Securitization'
    },
    checkPaymentStatus (currentStatus) {
      if (currentStatus === 'Payment is Past Due') {
        return true
      }
    },
    checkTotalPastDue (totalAmtDue) {
      if (totalAmtDue > 0) {
        return true
      }
    },
    clearData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    changeTheClass: function (updatedClass) {
      this.isActive = updatedClass
    },
    makeAPayment_NewTab: function (url) {
      window.open(url, '_blank')
    },
    startRedirectTimer () {
      // FAS-9643: send Pawnee users to NMEF CP after the migration notice has been shown for
      // NMEF_CP_REDIRECT_DELAY_MS. FAS-7978: a missing, 0 or non-numeric value disables the redirect.
      // Skip if the user already left the page (e.g. logged out) before the contracts call resolved.
      // Vue 3 upgrade: _isDestroyed is a Vue 2 internal (gone in Vue 3) — replace it with a flag set in
      // beforeUnmount, and rename the beforeDestroy hook below to beforeUnmount.
      const redirectDelay = Number(process.env.NMEF_CP_REDIRECT_DELAY_MS)
      if (!(redirectDelay > 0) || !isFinite(redirectDelay)) return
      if (this._isDestroyed) return
      this.redirectTimer = setTimeout(() => {
        window.location.assign('https://customer.nmef.com/?brand=pawnee')
      }, redirectDelay)
    }
  },
  created: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.items = response.data
        if (!this.items.length) {
          this.errored = true
        } else {
          this.startRedirectTimer()
        }
        this.loading = false
      })
      .catch((error) => {
        this.errored = true
        this.loading = false
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('items') &&
      this.items != null) {
        return true
      }
      return false
    }
  },
  mounted: function () {
    if (!auth.user.clientID) {
      this.$router.push('/login')
    }
  },
  beforeDestroy: function () {
    clearTimeout(this.redirectTimer)
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=PT+Sans:400,700,400italic&subset=latin,latin-ext,cyrillic-ext');
@import url('https://fonts.googleapis.com/css?family=Exo+2');

body {
  font-family: 'PT Sans';
}
h1, h2, h3, h4, h5, h6 {
  font-family: 'Exo 2';
}
#contractsView {
  background: #f0f0f0;
  padding: 30px;
  border-radius: 5px;
  margin-bottom: 50px;
  border: 1px solid #aaaaaa;
}
.text-danger {
  color:red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/contracts.vue